module.exports = __webpack_public_path__ + "img/loading.15f4ae83.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 0